import { render, staticRenderFns } from "./signStatisticsDetail.vue?vue&type=template&id=838527ec&scoped=true&"
import script from "./signStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./signStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./signStatisticsDetail.vue?vue&type=style&index=0&id=838527ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838527ec",
  null
  
)

export default component.exports